export function delay(milliseconds, value) {
    return new Promise((resolve) => {
        setTimeout(resolve.bind(undefined, value), milliseconds);
    })
}